import { hubApi } from '@/app/api/hubApi';

/**
 * Le carnet ne montre la touche « Scanner » que si le restaurant a un
 * programme de fidélité en marche. Même lecture publique que le site client
 * (`loyaltyApi.getLoyaltyProgram`, `{ enabled: false }` pour tout programme
 * éteint, impayé ou absent), mais portée par `hubApi` comme les réservations :
 * le carnet est un arbre voisin de la boutique et ne dépend pas du slice
 * fidélité client (RTK refuse un hook dont le middleware manque au store).
 */
export const waiterLoyaltyProgramApi = hubApi.injectEndpoints({
  endpoints: (build) => ({
    waiterLoyaltyProgram: build.query<{ enabled: boolean }, string>({
      query: (restaurantUuid) => `/loyalty/program/?restaurant=${encodeURIComponent(restaurantUuid)}`,
      transformResponse: (raw: { enabled?: unknown }) => ({ enabled: raw?.enabled === true }),
    }),
  }),
});

export const { useWaiterLoyaltyProgramQuery } = waiterLoyaltyProgramApi;
